<div *ngIf="feedbackMessage" class="feedback-message" [ngClass]="{'fade-out': fadeOut, 'hidden': fadeOut, 'error': messageType === 'error'}">
  	{{ feedbackMessage }}
</div>
<!-- Feedback button to open the feedback form -->
<div class="feedback-button-container">
    <button  (click)="toggleFeedbackForm()">Feedback</button>
</div>
<!-- Feedback form (only visible when isFeedbackFormVisible is true) -->
<div class="feedback-form" *ngIf="isFeedbackFormVisible">
    <h3 class="feedback-heading-text">Submit Feedback</h3>
    <label class="feedback-text">How satisfied are you with the experience of this tool?</label>
    <!-- Star rating options -->
    <div class="rating-options">
		<input type="radio" id="star1" name="satisfaction" value="5" (click)="onRatingClick(5)">
		<label for="star1" class="star"></label>
		
		<input type="radio" id="star2" name="satisfaction" value="4" (click)="onRatingClick(4)">
		<label for="star2" class="star"></label>
		
		<input type="radio" id="star3" name="satisfaction" value="3" (click)="onRatingClick(3)">
		<label for="star3" class="star"></label>
		
		<input type="radio" id="star4" name="satisfaction" value="2" (click)="onRatingClick(2)">
		<label for="star4" class="star"></label>
		
		<input type="radio" id="star5" name="satisfaction" value="1" (click)="onRatingClick(1)">
		<label for="star5" class="star"></label>
    </div>
    
    <label class="satisfaction-text">
		<span>Not Satisfied</span>
		<span>Satisfied</span>
    </label>
      <!-- Feedback text input box -->
    <textarea #feedbackBox class="feedback-box" placeholder="Share your feedback" rows="4"></textarea>
    <!-- Buttons to submit feedback or cancel the form -->
    <div class="feedback-buttons">
		<button (click)="sendFeedback(feedbackBox.value)">Send Feedback</button>
		<button (click)="toggleFeedbackForm()">Cancel</button>
    </div>
</div>